/* eslint-disable */
export default {
  methods: {
    autocompleteTag(keyword) {
      let t = '';
      switch (keyword.type) {
        case 'addr':
          t = `[${this.$t('stock_info.KEY_ADDR')}]`;
          break;
        case 'street':
          t = `[${this.$t('stock_info.KEY_STREET')}]`;
          break;
        case 'building':
          t = (keyword.ics === 's') ? 
            `[${this.$t('stock_info.KEY_SHOP')}]` : 
            `[${this.$t('stock_info.KEY_BUILDING')}]`;
          break;
        case 'emp':
          t = `[${this.$t('stock_info.KEY_EMP')}]`;
          break;
        case 'stockID':
          t = `[${this.$t('stock_info.KEY_STOCK_ID')}]`;
          break;
        case 'free_text':
          t = `[${this.$t('stock_info.KEY_FREE_TEXT')}]`;
        default:
          break;
      }
      return t;
    },
  },
};